<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { get } from "svelte/store";
    import { getContext } from "svelte";
    import { fade } from 'svelte/transition';
    import { sessionId } from "../utils/store";

    import {
        getStatusRoute,
        managePropertiesMeta
    } from "../utils/session";

    import {
        errorReasons,
        sessionCheck,
        login,
        listProperties
    } from "./api.svelte";


    export const ERROR_DISAPPEAR_AFTER = 5500;


    const router = getContext('router');

    let email = '';
    let password = '';

    let formError = false;
    let isLoading = false;
    let errorResetTimer = null;


    onMount(() => {

        checkLocalSession();

    });

    const getStoredSession = () => {

        return localStorage.getItem('ksessionid');
    };

    let checkLocalSession = async () => {

        let storedSession = getStoredSession();

        if (storedSession) {

            sessionId.set(storedSession);

            sessionCheck().then((sessionVerified) => {

                if (sessionVerified) {

                    sessionId.set(storedSession);
                    router.route('/');

                }

            });

        }

    };

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let loginHandler = (e) => {

        if (isLoading) return;

        if (email === '' || password === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        login(email, password).then((loginResult) => {

            isLoading = false;

            if (loginResult['status'] !== 'success') {

                formError = loginResult['reason'];
                startErrorResetTimer();

                return;

            }

            sessionId.set(loginResult['sessionid']);
            localStorage.setItem('ksessionid', loginResult['sessionid']);
            localStorage.setItem('kstatus', loginResult['userstatus']);

            listProperties().then((listResult) => {

                if (listResult['status'] !== 'success') {

                    // TODO: Handle errore
                    console.log(listResult);

                    return;

                }

                managePropertiesMeta(listResult['properties']);

                // Route user to finish onboarding
                if (loginResult['userstatus'] !== 'active') {

                    router.route(getStatusRoute(loginResult['userstatus']));
                    return;

                }

                router.route('/');

            });

        });

    };

</script>


<div id="login-container" class="forms-container">

    <img id="logo" src="images/logo.svg" alt="keyosh Logo" />

    <form on:submit|preventDefault={() => loginHandler()} id="loginform" class="forms">

        {#if formError}

            <div transition:fade id="error">

                {errorReasons[formError]}

            </div>

        {/if}

        <input
                bind:value={email}
                name="email"
                type="email"
                placeholder="E-Mail" />

        <input
                bind:value={password}
                name="password"
                type="password"
                placeholder="Passwort" />

        <button
                class={(isLoading) ? 'loading btn' : 'btn'}>

            <span>Login</span>
            <img src="images/button-loader.svg" />

        </button>

    </form>

    <div class="misclinks">

        <a href="/reset">Passwort vergessen?</a>

        <a href="/register">Noch keinen Account?</a>

    </div>

</div>


<style>

    #login-container {
    }

    img#logo {
        height: 4.26vh;
        margin-bottom: 5.86vh;
    }

    #loginform #error {
        width: 28vh;
        padding: 1.78vh;
        margin-bottom: 2.67vh;
        font-size: 1.8vh;
    }

    #loginform input,
    #loginform button {
        width: 28.6vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    #loginform button {
        width: 31.46vh;
        margin-bottom: 0;
    }

    .misclinks {
        margin-top: 4vh;
    }

    .misclinks a {
        font-size: 1.42vh;
    }

    .misclinks a:first-child {
        margin-bottom: 1.38vh;
    }

</style>
